// extracted by mini-css-extract-plugin
module.exports = {"flag":"FlagIcon_flag__9GOat"};